import React from "react";
import BaseTimeSeriesWidget from "../base-widgets/BaseTimeSeriesWidget";
import { StateTableWidget as StateTableWidgetComponent } from "../../../components/widgets";

const StateTableWidget = (props) => {
  return (
    <BaseTimeSeriesWidget {...props}>
      {(baseProps) => {
        return (
          <StateTableWidgetComponent {...baseProps} data={baseProps.streams} />
        );
      }}
    </BaseTimeSeriesWidget>
  );
};

export default StateTableWidget;
